import { Component, Input, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { NgFor, NgClass } from '@angular/common';

export enum StepStatus {
	CURRENT = 'current',
	ENABLED = 'enabled',
	DISABLED = 'disabled',
}

export interface StepClickedEvent {
	stepIndex: number;
}

export interface Step {
	label: string;
	status: StepStatus;
}

@Component({
	selector: 'copo-stepper',
	templateUrl: './stepper.component.html',
	styleUrl: './stepper.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [NgFor, MatRippleModule, NgClass]
})
export class StepperComponent {
	@Input() steps: Step[] = [];

	@Output() readonly stepClicked = new EventEmitter<StepClickedEvent>();

	onStepClicked(stepIndex: number, step: Step) {
		if (step.status === StepStatus.DISABLED || step.status === StepStatus.CURRENT) {
			return;
		}
		this.stepClicked.emit({ stepIndex });
	}
}
